module.exports = __webpack_public_path__ + "img/exam-ko-original.7c7b2bd0.webp";